import POProductType from "../types/POProductType";

interface POProductAction {
  type: string;
  payload?: any;
}

const initial_state = {
  poProductList: [],
  currentPage: 0,
  lastPage: 0,
  totalData: 0,
  from: 0,
  to: 0,
  updatePoProduct: null,
  poList: [],

  poOrderItemList: {
    data: [],
    total: 0,
    poOrders: {},
    grandTotal: 0,
    totalWithMarginPrice: 0,
    totalTax: 0,
    totalSupplyQty: 0,
    userDetails: {},
  },

  poVendorList: [],
  poSellerUniqueList: [],
};
const POProductReducer = (state = initial_state, action: POProductAction) => {
  switch (action.type) {
    case POProductType.SET_PO_PRODUCT_LIST:
      return {
        ...state,
        poProductList: action.payload.data,
        currentPage: action.payload.currentPage,
        lastPage: action.payload.lastPage,
        totalData: action.payload.totalData,
        from: action.payload.from,
        to: action.payload.to,
      };

    case POProductType.SET_UPLOAD_CSV_FILE: {
      return {
        ...state,
      };
    }

    case POProductType.REQUEST_PO_GENERATE:
      return {
        ...state,
      };

    case POProductType.CREATE_PO_GENERATE:
      return {
        ...state,
      };

    case POProductType.PO_LIST:
      return {
        ...state,
        poList: action.payload,
      };

    case POProductType.ORDER_ITEMS:
      return {
        ...state,
        poOrderItemList: {
          data: action.payload.data,
          total: action.payload.total,
          poOrders: action.payload.poOrders,
          grandTotal: action.payload.grandTotal,
          totalWithMarginPrice: action.payload.totalWithMarginPrice,
          totalTax: action.payload.totalTax,
          totalSupplyQty: action.payload.totalSupplyQty,
          userDetails: action.payload.userDetails,
        },
      };

    case POProductType.DELETE_ORDER_ITEMS:
      return {
        ...state,
      };

    case POProductType.PO_ORDER_ACCEPTANCE:
      return {
        ...state,
      };

    case POProductType.PO_VENDOR_LIST:
      return {
        ...state,
        poVendorList: action.payload,
      };

    case POProductType.PO_SELLER_UNIQUE_LIST:
      return {
        ...state,
        poSellerUniqueList: action.payload,
      };

    case POProductType.SET_UPLOAD_DDC_CSV_FILE: {
      return {
        ...state,
      };
    }

    case POProductType.SET_DELIVERY_CHARGE: {
      return {
        ...state,
      };
    }

    case POProductType.CANCEL_ORDER_ITEM: {
      return {
        ...state,
      };
    }

    case POProductType.UPDATE_LANDING_COST: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }
};

export default POProductReducer;
